import { useLogger } from '@/hooks/useLogger';
import { Navigate } from 'react-router-dom';

export default function Page() {
  const { logInfo } = useLogger();
  logInfo('Redirecting to `/calendar/appointments` from `/calendar`');
  return <Navigate to="appointments" />;
}
